export enum ETypWarrantu {
    T = 'T',
    N = 'N',
    K = 'K'
}
